// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609231805/js/" + chunkId + "." + {"44":"fe5b6521","225":"07e1de3c","481":"766a0907","486":"47bdb06b","770":"79b82d80"}[chunkId] + ".0.9003821655920388.chunk.js";
};